export default __webpack_public_path__ + "static/media/ecobank.2d5109ef.webp";